import { IconMail } from '@tabler/icons-react'
import React, { useContext } from 'react'
import { ThemeContext } from 'theme/ThemeProvider'
import SettingTitle from '../SettingTitle'
import IdentifyVerification from './IdentifyVerification'
import { AuditSettingContainer, AuditSettingSection } from './styles'

const AuditSetting = () => {
	const { textw } = useContext(ThemeContext).theme.COLORS
	const levelOne = [
		{
			title: 'successfullyRegistered',
			icon: <IconMail color={textw} size={18} />,
		},
	]
	const levelTwo = [
		{
			title: 'id',
			icon: <IconMail color={textw} size={18} />,
		},
		{
			title: 'selfie',
			icon: <IconMail color={textw} size={18} />,
		},
	]
	const levelThree = [
		{
			title: 'proofOfAddress',
			icon: <IconMail color={textw} size={18} />,
		},
	]
	return (
		<AuditSettingSection>
			<SettingTitle title={'audit'} />
			<AuditSettingContainer>
				<IdentifyVerification level={levelOne} />
				<IdentifyVerification level={levelTwo} />
				<IdentifyVerification level={levelThree} last={true} />
			</AuditSettingContainer>
		</AuditSettingSection>
	)
}

export default AuditSetting
